import { Injectable } from '@angular/core';
import { CadastrePoint, Parcel } from '../models/cadastre.models';
import { GeometryService } from './geometry.service';

@Injectable({ providedIn: 'root' })
export class CadastreDataService {
  readonly points: CadastrePoint[];

  readonly parcels: Parcel[] = [
    {
      name: '193',
      ez: '3348',
      cadastreType: 'Rechtsstatus: Grundsteuerkataster',
      pointIds: [8232, 8231, 24611, 24610, 8227, 8226, 8225, 8224, 8223, 8222, 8236, 8235, 8234, 8233],
      strokeColor: '#2563eb',
      pdfUrl: 'assets/pdfs/01206-EZ-3348.pdf'
    },
    {
      name: '882/2',
      ez: '3349',
      cadastreType: 'Rechtsstatus: Grenzkataster',
      pointIds: [8241, 8242, 8243, 8233, 8234, 8235, 8236, 8237, 8238, 8239, 8240],
      strokeColor: '#0891b2',
      pdfUrl: 'assets/pdfs/01206-EZ-3349.pdf'
    },
    {
      name: '189/8',
      ez: '1703',
      cadastreType: 'Rechtsstatus: Grenzkataster',
      pointIds: [8238, 8237, 8236, 8222, 8247],
      strokeColor: '#16a34a',
      pdfUrl: 'assets/pdfs/01206-EZ-1703.pdf'
    }
  ];

  readonly columns = [
    { name: 'Saeule 1', fromPointId: 8240, toPointId: 8244, color: '#dc2626' },
    { name: 'Saeule 2', fromPointId: 8246, toPointId: 8245, color: '#f97316' }
  ];

  constructor(private readonly geometry: GeometryService) {
    const raw = [
      [8232, 24, -5018.75, 5340697.47],
      [8231, 24, -5050.37, 5340740.97],
      [24611, 20, -5068.92, 5340729.67],
      [24610, 20, -5061.65, 5340711.67],
      [8227, 20, -5060.53, 5340708.90],
      [8226, 20, -5057.97, 5340702.97],
      [8225, 20, -5052.96, 5340692.00],
      [8224, 20, -5047.88, 5340681.55],
      [8223, 24, -5044.79, 5340674.84],
      [8222, 24, -5043.32, 5340671.65],
      [8241, 24, -5028.72, 5340665.20],
      [8242, 24, -5028.58, 5340671.99],
      [8243, 24, -5032.07, 5340684.46],
      [8233, 24, -5033.52, 5340686.95],
      [8234, 24, -5035.97, 5340685.20],
      [8235, 24, -5034.86, 5340683.28],
      [8236, 24, -5033.87, 5340679.74],
      [8237, 24, -5031.59, 5340671.60],
      [8238, 24, -5031.75, 5340663.60],
      [8239, 20, -5031.19, 5340663.85],
      [8240, 20, -5029.07, 5340665.28],
      [8244, 20, -5029.65, 5340665.42],
      [8245, 20, -5028.12, 5340665.07],
      [8246, 20, -5027.57, 5340664.94],
      [8247, 24, -5038.30, 5340660.75]
    ] as const;

    this.points = raw.map(([id, typ, x, y]) => ({
      id,
      typ,
      x,
      y,
      ...this.geometry.originalToWgs84(x, y)
    }));
  }

  getPointById(id: number): CadastrePoint {
    const point = this.points.find(p => p.id === id);
    if (!point) throw new Error(`Point not found: ${id}`);
    return point;
  }
}
